import isEmpty from 'lodash/isEmpty'

import { date } from 'configuration/dayjs'
import {
    AD_ACCOUNT_TYPES,
    ADVANCED_PRODUCT_TITLE,
    COUNTRIES,
    DATES,
    LABELS,
    METRIC_FILTERS,
    ORG_BRANDS,
    PRODUCT_ASINS,
    SOV_METADATA_BRANDS,
    PRODUCT_TITLE,
    SC_ACCOUNTS,
    VC_PROGRAMS,
} from 'const/filters'
import { PRODUCT_LABELS } from 'const/resourceTypes'
import { isNonEmptyArray } from 'helpers/typeGuard'
import { formatDateFromFilter } from 'helpers/utils'
import { FiltersState, VcApiSalesDiagnosticFactsParams } from 'types'

import { formatBooleanFilter } from '../filters'

import { formatMetricFiltersForParams } from './metrics'

export const formatFilters = (
    filters: FiltersState,
    _hasHourlyData = false,
    fiscalYearStartMonth?: number
): VcApiSalesDiagnosticFactsParams => {
    let params: VcApiSalesDiagnosticFactsParams = {}

    const productTitle = filters[PRODUCT_TITLE]
    if (!!productTitle && productTitle !== '') {
        params.product_title__icontains = productTitle
    }

    const dates = filters[DATES]
    const { start, end } = formatDateFromFilter(
        dates,
        date(),
        filters.rangeLag,
        fiscalYearStartMonth
    )
    params.report_date_min = start
    params.report_date_max = end

    const countries = filters[COUNTRIES]
    if (isNonEmptyArray(countries)) {
        params.marketplace__in = countries.map((item) => item.value).join()
    }

    const asins = filters[PRODUCT_ASINS]
    if (isNonEmptyArray(asins)) {
        params.asin__in = asins.map((item) => item.value).join()
    }

    const labels = filters[LABELS]
    if (isNonEmptyArray(labels)) {
        params.complex_label_filter = formatBooleanFilter(
            filters[LABELS],
            PRODUCT_LABELS
        )
    }

    if (!isEmpty(filters[ADVANCED_PRODUCT_TITLE])) {
        params.boolean_filter = formatBooleanFilter(
            filters[ADVANCED_PRODUCT_TITLE],
            ADVANCED_PRODUCT_TITLE
        )
    }

    const metricFilters = filters[METRIC_FILTERS]
    if (isNonEmptyArray(metricFilters)) {
        params = { ...params, ...formatMetricFiltersForParams(metricFilters) }
    }

    const adAccountTypes = filters[AD_ACCOUNT_TYPES]
    if (isNonEmptyArray(adAccountTypes)) {
        params.account_type__in = adAccountTypes
            .map((item) => item.value)
            .join()
    }

    if (isNonEmptyArray(filters[SC_ACCOUNTS])) {
        params.seller_central_account_id__in = filters[SC_ACCOUNTS].map(
            (item) => item.value
        ).join()
    }

    const programs = filters[VC_PROGRAMS]
    if (isNonEmptyArray(programs)) {
        params.program__in = programs.map((item) => item.value).join()
    }

    const orgBrandValues = isNonEmptyArray(filters[ORG_BRANDS])
        ? filters[ORG_BRANDS].map((item) => item.value)
        : []
    const sovBrandValues = isNonEmptyArray(filters[SOV_METADATA_BRANDS])
        ? filters[SOV_METADATA_BRANDS].map((item) => item.value)
        : []
    const allBrands = [...new Set([...orgBrandValues, ...sovBrandValues])]
    if (allBrands.length > 0) {
        params.metadata__brand__in = allBrands.join()
    }

    return params
}
